import Link from "next/link"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { Search } from "components/ui"
import cn from "classnames"
import s from "./Navbar.module.css"
import { useEffect, useRef, useState } from "react"
import Image from "next/legacy/image"
import NotiCation from "components/Noticatoin/NotiCation"
import PopupWarring from "components/Noticatoin/PopupWarring"
import { apiNoticatoin } from "api"
import { initializeApp } from "firebase/app"
import { getAccessToken } from "lib/Cookies"

// import { getMessaging } from "firebase/messaging/sw";

import { getMessaging, onMessage } from "firebase/messaging"
import useStore from "components/ui/Context"
import NavbarMobile from "./NavbarMobile"
import { Fragment } from "react"

const Profile = dynamic(() => import("components/common/Profile"), { ssr: false })

const id = "esports"

const icSport = (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6961 8.23271H10.5065C9.86477 8.23271 9.34265 8.77084 9.34265 9.43226C9.34265 10.0937 9.86477 10.6318 10.5065 10.6318H17.649C19.1437 10.6318 20.3597 11.8852 20.3597 13.4257V14.6739H25.2399C25.7574 14.6739 26.2553 14.762 26.7203 14.9244V3.75H15.4069V5.43885C15.4069 6.97937 14.1909 8.23271 12.6961 8.23271V8.23271Z"
      fill="white"
      fillOpacity="0.87"
    />
    <path
      d="M13.4519 14.6739H18.8129V13.4257C18.8129 12.7643 18.2907 12.2262 17.649 12.2262H10.5065C9.01185 12.2262 7.79579 10.9728 7.79579 9.43231C7.79579 7.89179 9.01185 6.63846 10.5065 6.63846H12.6961C13.3379 6.63846 13.86 6.10032 13.86 5.4389V3.75H1.87512V19.926H8.84576V19.4213C8.84576 16.8036 10.9121 14.6739 13.4519 14.6739Z"
      fill="white"
      fillOpacity="0.87"
    />
    <path d="M17.3057 24.1686L15.0894 26.2501H23.7189L21.6249 24.1686H17.3057Z" fill="white" fillOpacity="0.87" />
    <path
      d="M8.84561 21.467H1.87512V23.0613C1.87512 24.8224 3.26025 26.25 4.96888 26.25H9.27281C9.00164 25.7664 8.84561 25.2061 8.84561 24.6085V21.467Z"
      fill="white"
      fillOpacity="0.87"
    />
    <path
      d="M25.2003 16.2123H13.4123C11.7254 16.2123 10.353 17.6267 10.353 19.3653V24.5526C10.353 25.4885 11.0918 26.25 11.9999 26.25H12.0556C12.4669 26.25 12.8608 26.0927 13.1648 25.8072L16.667 22.5182H22.2096L25.4853 25.7743C25.7939 26.081 26.1999 26.25 26.6286 26.25C27.5367 26.25 28.2755 25.4885 28.2755 24.5526V19.3818C28.2755 17.6341 26.896 16.2123 25.2003 16.2123V16.2123ZM13.2647 22.331V20.9568H11.9314V19.3625H13.2647V17.9882H14.8116V19.3625H16.145V20.9568H14.8116V22.331H13.2647ZM23.817 22.331V20.9568H22.4836V19.3625H23.817V17.9882H25.3638V19.3625H26.6972V20.9568H25.3638V22.331H23.817Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)

const icLiveScore = (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="white" fillOpacity="0.87" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30 19.6288H24.2371V10.3712H30V4.54358H15.8789V10.4547C18.0125 10.8664 19.6291 12.748 19.6291 15C19.6291 17.2521 18.0125 19.1336 15.8789 19.5453V25.4565H30V19.6288Z"
      fill="white"
      fillOpacity="0.87"
    />
    <path d="M4.03811 12.129H0V17.8709H4.03811V12.129Z" fill="white" fillOpacity="0.87" />
    <path
      d="M15.8789 12.2664C17.0336 12.6384 17.8713 13.7232 17.8713 15C17.8713 16.2767 17.0336 17.3616 15.8789 17.7337V12.2664Z"
      fill="white"
      fillOpacity="0.87"
    />
    <path d="M25.9949 12.129H29.9999V17.8709H25.9949V12.129Z" fill="white" fillOpacity="0.87" />
    <path
      d="M14.121 17.7336C12.9663 17.3615 12.1286 16.2767 12.1286 15C12.1286 13.7232 12.9663 12.6384 14.121 12.2663V17.7336Z"
      fill="white"
      fillOpacity="0.87"
    />
    <path
      d="M10.3709 15C10.3709 17.252 11.9875 19.1336 14.1211 19.5453V25.4565H0V19.6288H5.79592V10.3713H0V4.54358H14.1211V10.4546C11.9875 10.8664 10.3709 12.7479 10.3709 15Z"
      fill="white"
      fillOpacity="0.87"
    />
  </svg>
)

const icHome = (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="white" fillOpacity="0.87" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_26725_172695)">
      <path
        d="M15 0.499939L0 14.5V16.5H4.00002V29.5H11V21.4999H19V29.5H26V16.5H30V14.5L15 0.499939Z"
        fill="url(#paint0_linear_26725_172695)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_26725_172695"
        x1="10.7432"
        y1="1.02246"
        x2="9.06279"
        y2="29.4005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_26725_172695">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const icChannels = (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="white" xmlns="http://www.w3.org/2000/svg">
    <g id="icons">
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M6.36363 13.3091H4.32727C4.10909 13.3091 3.96363 13.1636 3.96363 12.9455C3.96363 12.7273 4.10909 12.5818 4.32727 12.5818H6.36363C6.58182 12.5818 6.72727 12.7273 6.72727 12.9455C6.72727 13.1636 6.58182 13.3091 6.36363 13.3091Z"
            fill="white"
          />
        </g>
        <g id="Group_3">
          <path
            id="Vector_2"
            d="M20.2182 18.7273C20.0364 18.7273 19.8545 18.5818 19.8545 18.3636C19.8545 18.1455 20 18 20.2182 18L22.2182 17.9636C22.5818 17.9636 22.8727 17.6727 22.8727 17.3091V5.49091C22.8727 5.12727 22.5818 4.83636 22.2182 4.83636H1.74545C1.38182 4.83636 1.09091 5.12727 1.09091 5.49091V17.3091C1.09091 17.6727 1.38182 17.9636 1.74545 17.9636L16.4364 18C16.6545 18 16.8 18.1818 16.8 18.3636C16.8 18.5818 16.6545 18.7273 16.4364 18.7273L1.74545 18.6909C0.981818 18.6909 0.363636 18.0727 0.363636 17.3091V5.49091C0.363636 4.72727 0.981818 4.10909 1.74545 4.10909H22.2182C22.9818 4.10909 23.6 4.72727 23.6 5.49091V17.3091C23.6 18.0727 22.9818 18.6909 22.2182 18.6909L20.2182 18.7273Z"
            fill="white"
          />
        </g>
        <g id="Group_4">
          <path
            id="Vector_3"
            d="M21.8545 17.2727H20.4364C20.2182 17.2727 20.0727 17.1273 20.0727 16.9091C20.0727 16.6909 20.2182 16.5455 20.4364 16.5455H21.4909V6.25455H2.50909V16.5455H16.0364C16.2545 16.5455 16.4 16.6909 16.4 16.9091C16.4 17.1273 16.2545 17.2727 16.0364 17.2727H2.14545C1.92727 17.2727 1.78182 17.1273 1.78182 16.9091V5.89091C1.78182 5.67273 1.92727 5.52727 2.14545 5.52727H21.8545C22.0727 5.52727 22.2182 5.67273 22.2182 5.89091V16.9091C22.2182 17.1273 22.0727 17.2727 21.8545 17.2727Z"
            fill="white"
          />
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_4"
              d="M20.2545 23.6364H16.4727C16.2545 23.6364 16.1091 23.4909 16.1091 23.2727V12.1455C16.1091 11.9273 16.2545 11.7818 16.4727 11.7818H20.2545C20.4727 11.7818 20.6182 11.9273 20.6182 12.1455V23.2727C20.6182 23.4909 20.4727 23.6364 20.2545 23.6364ZM16.8364 22.9091H19.8909V12.5091H16.8364V22.9091Z"
              fill="white"
            />
          </g>
          <g id="Group_7">
            <path
              id="Vector_5"
              d="M18.3636 15.8545C17.7455 15.8545 17.2727 15.3818 17.2727 14.7636C17.2727 14.1455 17.7455 13.6727 18.3636 13.6727C18.9818 13.6727 19.4545 14.1455 19.4545 14.7636C19.4545 15.3818 18.9818 15.8545 18.3636 15.8545ZM18.3636 14.4C18.1455 14.4 18 14.5455 18 14.7636C18 14.9818 18.1455 15.1273 18.3636 15.1273C18.5818 15.1273 18.7273 14.9818 18.7273 14.7636C18.7273 14.5455 18.5818 14.4 18.3636 14.4Z"
              fill="white"
            />
          </g>
          <g id="Group_8">
            <g id="Group_9">
              <path
                id="Vector_6"
                d="M17.7455 17.8909H17.6727C17.4545 17.8909 17.3091 17.7455 17.3091 17.5273C17.3091 17.3091 17.4545 17.1636 17.6727 17.1636H17.7455C17.9636 17.1636 18.1091 17.3091 18.1091 17.5273C18.1091 17.7455 17.9636 17.8909 17.7455 17.8909Z"
                fill="white"
              />
            </g>
            <g id="Group_10">
              <path
                id="Vector_7"
                d="M19.0182 17.8909H18.9455C18.7273 17.8909 18.5818 17.7455 18.5818 17.5273C18.5818 17.3091 18.7273 17.1636 18.9455 17.1636H19.0182C19.2364 17.1636 19.3818 17.3091 19.3818 17.5273C19.3818 17.7455 19.2364 17.8909 19.0182 17.8909Z"
                fill="white"
              />
            </g>
          </g>
          <g id="Group_11">
            <g id="Group_12">
              <path
                id="Vector_8"
                d="M17.7455 19.2H17.6727C17.4545 19.2 17.3091 19.0545 17.3091 18.8364C17.3091 18.6182 17.4545 18.4727 17.6727 18.4727H17.7455C17.9636 18.4727 18.1091 18.6182 18.1091 18.8364C18.1091 19.0545 17.9636 19.2 17.7455 19.2Z"
                fill="white"
              />
            </g>
            <g id="Group_13">
              <path
                id="Vector_9"
                d="M19.0182 19.2H18.9455C18.7273 19.2 18.5818 19.0545 18.5818 18.8364C18.5818 18.6182 18.7273 18.4727 18.9455 18.4727H19.0182C19.2364 18.4727 19.3818 18.6182 19.3818 18.8364C19.3818 19.0545 19.2364 19.2 19.0182 19.2Z"
                fill="white"
              />
            </g>
          </g>
          <g id="Group_14">
            <g id="Group_15">
              <path
                id="Vector_10"
                d="M17.7455 20.5091H17.6727C17.4545 20.5091 17.3091 20.3636 17.3091 20.1455C17.3091 19.9273 17.4545 19.7818 17.6727 19.7818H17.7455C17.9636 19.7818 18.1091 19.9273 18.1091 20.1455C18.1091 20.3636 17.9636 20.5091 17.7455 20.5091Z"
                fill="white"
              />
            </g>
            <g id="Group_16">
              <path
                id="Vector_11"
                d="M19.0182 20.5091H18.9455C18.7273 20.5091 18.5818 20.3636 18.5818 20.1455C18.5818 19.9273 18.7273 19.7818 18.9455 19.7818H19.0182C19.2364 19.7818 19.3818 19.9273 19.3818 20.1455C19.3818 20.3636 19.2364 20.5091 19.0182 20.5091Z"
                fill="white"
              />
            </g>
          </g>
          <g id="Group_17">
            <g id="Group_18">
              <path
                id="Vector_12"
                d="M17.7455 21.8545H17.6727C17.4545 21.8545 17.3091 21.7091 17.3091 21.4909C17.3091 21.2727 17.4545 21.1273 17.6727 21.1273H17.7455C17.9636 21.1273 18.1091 21.2727 18.1091 21.4909C18.1091 21.7091 17.9636 21.8545 17.7455 21.8545Z"
                fill="white"
              />
            </g>
            <g id="Group_19">
              <path
                id="Vector_13"
                d="M19.0182 21.8545H18.9455C18.7273 21.8545 18.5818 21.7091 18.5818 21.4909C18.5818 21.2727 18.7273 21.1273 18.9455 21.1273H19.0182C19.2364 21.1273 19.3818 21.2727 19.3818 21.4909C19.3818 21.7091 19.2364 21.8545 19.0182 21.8545Z"
                fill="white"
              />
            </g>
          </g>
        </g>
        <g id="Group_20">
          <path
            id="Vector_14"
            d="M10.7636 4.8C10.5455 4.8 10.4 4.65454 10.4 4.43636C10.4 3.34545 11.2364 2.50909 12.2909 2.50909C13.3455 2.50909 14.1818 3.38182 14.1818 4.43636C14.1818 4.65454 14.0364 4.8 13.8182 4.8C13.6 4.8 13.4545 4.65454 13.4545 4.43636C13.4545 3.81818 12.9091 3.27273 12.2909 3.27273C11.6727 3.27273 11.1273 3.81818 11.1273 4.43636C11.1273 4.65454 10.9818 4.8 10.7636 4.8Z"
            fill="white"
          />
        </g>
        <g id="Group_21">
          <path
            id="Vector_15"
            d="M13.3818 3.70909C13.2727 3.70909 13.2 3.67273 13.1273 3.6C12.9818 3.45455 12.9818 3.23636 13.1273 3.09091L15.7455 0.472727C15.8909 0.327272 16.1091 0.327272 16.2545 0.472727C16.4 0.618181 16.4 0.836363 16.2545 0.981818L13.6364 3.6C13.5636 3.67273 13.4909 3.70909 13.3818 3.70909Z"
            fill="white"
          />
        </g>
        <g id="Group_22">
          <path
            id="Vector_16"
            d="M11.2364 3.67273C11.1273 3.67273 11.0545 3.63636 10.9818 3.56364L8.4 0.981818C8.25455 0.836363 8.25455 0.618181 8.4 0.472727C8.54545 0.327272 8.76364 0.327272 8.90909 0.472727L11.4909 3.05455C11.6364 3.2 11.6364 3.41818 11.4909 3.56364C11.4182 3.63636 11.3455 3.67273 11.2364 3.67273Z"
            fill="white"
          />
        </g>
        <g id="Group_23">
          <g id="Group_24">
            <path
              id="Vector_17"
              d="M12.6182 13.3091C12.5091 13.3091 12.4364 13.2727 12.3636 13.2C12.1091 12.9455 11.6364 12.9455 11.3818 13.2C11.2364 13.3455 11.0182 13.3455 10.8727 13.2C10.7273 13.0545 10.7273 12.8364 10.8727 12.6909C11.4182 12.1455 12.3273 12.1455 12.8727 12.6909C13.0182 12.8364 13.0182 13.0545 12.8727 13.2C12.8 13.2727 12.7273 13.3091 12.6182 13.3091Z"
              fill="white"
            />
          </g>
          <g id="Group_25">
            <path
              id="Vector_18"
              d="M15.6 10.4C15.4909 10.4 15.4182 10.3636 15.3455 10.2909C13.4182 8.36364 10.2909 8.36364 8.36364 10.2909C8.21818 10.4364 8 10.4364 7.85455 10.2909C7.70909 10.1455 7.70909 9.92727 7.85455 9.78182C10.0727 7.56364 13.6364 7.56364 15.8545 9.78182C16 9.92727 16 10.1455 15.8545 10.2909C15.7818 10.3636 15.7091 10.4 15.6 10.4Z"
              fill="white"
            />
          </g>
          <g id="Group_26">
            <path
              id="Vector_19"
              d="M14.1091 11.8545C14 11.8545 13.9273 11.8182 13.8545 11.7455C13.3091 11.2 12.6182 10.9091 11.8909 10.9091C11.1636 10.9091 10.4364 11.2 9.92727 11.7455C9.78182 11.8909 9.56364 11.8909 9.41818 11.7455C9.27273 11.6 9.27273 11.3818 9.41818 11.2364C10.0727 10.5818 10.9818 10.2182 11.9273 10.2182C12.8727 10.2182 13.7455 10.5818 14.4364 11.2364C14.5818 11.3818 14.5818 11.6 14.4364 11.7455C14.2909 11.8182 14.2182 11.8545 14.1091 11.8545Z"
              fill="white"
            />
          </g>
          <g id="Group_27">
            <path
              id="Vector_20"
              d="M11.8545 14.9091H11.7818C11.5636 14.9091 11.4182 14.7636 11.4182 14.5455C11.4182 14.3273 11.5636 14.1818 11.7818 14.1818H11.8545C12.0727 14.1818 12.2182 14.3273 12.2182 14.5455C12.2182 14.7636 12.0727 14.9091 11.8545 14.9091Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_28">
          <path
            id="Vector_21"
            d="M7.6 15.1273H4.32727C4.10909 15.1273 3.96363 14.9818 3.96363 14.7636C3.96363 14.5455 4.10909 14.4 4.32727 14.4H7.6C7.81818 14.4 7.96363 14.5455 7.96363 14.7636C7.96363 14.9818 7.81818 15.1273 7.6 15.1273Z"
            fill="white"
          />
        </g>
        <g id="Group_29">
          <path
            id="Vector_22"
            d="M19.6 10.1091H18.2182C18 10.1091 17.8545 9.96364 17.8545 9.74545C17.8545 9.52727 18 9.38182 18.2182 9.38182H19.6C19.8182 9.38182 19.9636 9.52727 19.9636 9.74545C19.9636 9.96364 19.8182 10.1091 19.6 10.1091Z"
            fill="white"
          />
        </g>
        <g id="Group_30">
          <path
            id="Vector_23"
            d="M19.6 8.29091H17.4182C17.2 8.29091 17.0545 8.14546 17.0545 7.92727C17.0545 7.70909 17.2 7.56364 17.4182 7.56364H19.6C19.8182 7.56364 19.9636 7.70909 19.9636 7.92727C19.9636 8.14546 19.8182 8.29091 19.6 8.29091Z"
            fill="white"
          />
        </g>
      </g>
    </g>
  </svg>
)

const listMenus = [
  {
    title: "Trang chủ",
    path: "/",
    icon: icHome
  },
  {
    title: "Livescore",
    path: "/livescore",
    icon: icLiveScore
  },
  {
    title: "Esports",
    path: `/category?id=${id}`,
    icon: icSport,
    animationText: true
  },
  {
    title: "Truyền hình",
    path: `/channels`,
    icon: icChannels
  },
  {
    title: "Short video",
    path: `/short?type=all`,
    icon: icChannels
  }
]

export default function Navbar() {
  const router = useRouter()
  const [index, setIndex] = useState("/")
  const [isBlack, setBlack] = useState(false)
  const isMounter = useRef()
  const [isMobile, setIsMobile] = useState(false)
  const [isShowNoti, setIsShowNoti] = useState(false)
  const [isShowNotiWarring, setIsShowNotiWarring] = useState(false)
  const [count, setCount] = useState(0)
  const { userInfo } = useStore()
  const [isNav, setIsNav] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [text, setText] = useState(router?.query?.q || "")

  async function getCountNoti() {
    try {
      if (getAccessToken()) {
        const { data } = await apiNoticatoin.getCount()
        setCount(data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  function handerShowModal() {
    if (getAccessToken()) {
      setIsShowNoti(!isShowNoti)
    } else {
      setIsShowNotiWarring(!isShowNotiWarring)
    }
  }

  function togleNav() {
    setIsNav((c) => !c)
  }

  function onClickNav(event) {
    if (event.target.id == "nav") {
      CloseModle()
    }
  }

  function CloseModle() {
    setIsShowNotiWarring(false)
    setIsShowNoti(false)
  }

  useEffect(() => {
    if (process.browser) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 1) {
          if (!isMounter.current) {
            setBlack(true)
            isMounter.current = true
          }
        } else {
          if (isMounter.current) {
            setBlack(false)
            isMounter.current = false
          }
        }
      })
      return () => window.removeEventListener("scroll", null)
    }
  }, [])

  useEffect(() => {
    setIndex(router.asPath)
  }, [router])

  useEffect(() => {
    if (getAccessToken()) {
      getCountNoti()
    }
    if (userInfo) {
      setIsShowNotiWarring(false)
    }
  }, [userInfo])

  function togleIsMobile() {
    if (window.innerWidth < 980) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }
  useEffect(() => {
    if (getAccessToken()) {
      getCountNoti()
    }
    togleIsMobile()
    window.addEventListener("resize", togleIsMobile)
    return () => {
      if (isMobile) window?.removeEventListener("resize", togleIsMobile)
    }
  }, [isMobile])

  useEffect(() => {
    const firebaseApp = initializeApp({
      apiKey: "AIzaSyChP2yOm3j5hQHa-YdLuqn8XhkAYHQLdwI",
      authDomain: "onplus-5a601.firebaseapp.com",
      projectId: "onplus-5a601",
      storageBucket: "onplus-5a601.appspot.com",
      messagingSenderId: "190122352939",
      appId: "1:190122352939:web:6d086f9f254fc640b6256e",
      measurementId: "G-8CTEDKZ2SV"
    })

    let messaging
    try {
      messaging = getMessaging(firebaseApp)

      onMessage(messaging, (payload) => {
        if (payload?.messageId) {
          const timer = setTimeout(() => {
            getCountNoti()
          }, [2000])
          return () => {
            clearTimeout(timer)
          }
        }
        // ...
      })
    } catch (err) {
      console.error("Failed to initialize Firebase Messaging", err)
    }
  }, [])

  function onSearch() {
    if (!router.pathname.includes("tim-kiem") && text.length <= 0) {
      setShowSearch(!showSearch)
    } else {
      if (text.length > 0) {
        router.push(`/tim-kiem?q=${text}`)
        setShowSearch(true)
      }
    }
    CloseModle()
  }

  function onChange(e) {
    setText(e.target.value)
  }

  function onKeyPress(e) {
    if (e.charCode === 13 && text.length > 0) {
      router.push(`/tim-kiem?q=${text}`)
    }
  }

  useEffect(() => {
    // console.log(router)
    if (router.pathname !== "/tim-kiem") setText("")
  }, [router])

  return (
    <div>
      {!isMobile && (
        <nav
          className={cn(
            s.nav,
            isBlack ? s.black : s.white,
            "px-10 2xl:px-12 top-0 text-white w-full fixed z-40 border-b border-dark-500"
          )}
          id="nav"
          onClick={onClickNav}
        >
          <div className="container__screen m-auto  w-full justify-between items-center flex">
            <div className="flex relative items-center">
              <Link
                href="/"
                onClick={() => {
                  CloseModle()
                }}
              >
                <div className="py-1 flex mr-2 md:mr-6" style={{ minWidth: 141 }}>
                  <div className="flex gap-3 items-center">
                    {/* <img src="/logo/logo.png" width={34} height={34} alt="Onplus" /> */}
                    <img src="/logo/logo-wc.png" width={34} height={34} alt="Onplus" />
                    <div className="min-w-[3px] bg-slate-400 h-7"></div>
                    <div>vinaphone</div>
                  </div>
                </div>
              </Link>
              <div className="items-center  hidden md:flex">
                <div className="flex items-center">
                  {listMenus.map(({ title, path }, key) => {
                    return (
                      <Fragment key={key}>
                        {title === "Tin tức" ? (
                          <a
                            className="px-2 h-16 flex items-center text-dark-300"
                            href="https://onsports.vn/"
                            target="__blank"
                          >
                            Tin tức
                          </a>
                        ) : (
                          <Link
                            href={path}
                            key={key}
                            onClick={() => {
                              CloseModle()
                            }}
                          >
                            <div
                              className={cn("px-2 h-16 flex items-center text-dark-300 relative", {
                                [s.active]: index === path
                              })}
                            >
                              {title}
                              {title === "Esports" && (
                                <span
                                  className={cn({
                                    [s.animationText]: title === "Esports"
                                  })}
                                >
                                  HOT
                                </span>
                              )}
                            </div>
                          </Link>
                        )}
                      </Fragment>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="flex space-x-4 justify-center items-center">
              <div
                onClick={() => {
                  CloseModle()
                }}
              >
                <Search />
              </div>
              <Link
                href="/subscription"
                onClick={() => {
                  CloseModle()
                }}
              >
                <button
                  className={
                    "rounded-3xl py-1 px-4 text-base flex items-center bg-primary-500 space-x-4 hover:bg-primary-hover font-medium text-white w-28 justify-center"
                  }
                  style={{ backgroundImage: "linear-gradient(183.51deg, #52B5F9 5.4%, #024EC0 97.93%)" }}
                >
                  MUA GÓI
                </button>
              </Link>
              <div onClick={handerShowModal} className="cursor-pointer" id="bell">
                {count && userInfo?.id ? imgBell : imgBellDefault}
              </div>
              <div
                onClick={() => {
                  CloseModle()
                }}
              >
                <Profile />
              </div>
              {isShowNoti && <NotiCation callBackgetCountNoti={getCountNoti} setIsShowNoti={setIsShowNoti} />}
              {isShowNotiWarring && <PopupWarring setIsShowNotiWarring={setIsShowNotiWarring} />}
            </div>
          </div>
        </nav>
      )}
      {isMobile === true && (
        <nav
          className={cn(
            s.nav,
            isBlack ? s.black : s.white,
            "top-0 text-white w-full px-4 fixed z-40 border-b border-dark-500 flex md:px-3 justify-between h-[52px]"
          )}
          id="nav"
        >
          <div
            className="flex space-x-3 items-center"
            onClick={() => {
              CloseModle()
            }}
          >
            <button onClick={togleNav} className={`text-slate-200 rounded z-40`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h8m-8 6h16" />
              </svg>
            </button>

            {!showSearch && (
              <Link
                href="/"
                onClick={() => {
                  CloseModle()
                }}
              >
                <div className="py-1 flex mr-2 md:mr-6 text-sm">
                  <div className="flex gap-2 items-center">
                    {/* Logo thường: */}
                    {/* <img src="/logo/logo.png" width={34} height={34} alt="xx" /> */}
                    <img src="/logo/logo-wc.png" width={34} height={34} alt="xx" />
                    <div className="min-w-[1px] bg-slate-400 h-5"></div>
                    <div>vinaphone</div>
                  </div>
                </div>
              </Link>
            )}
          </div>
          <div className="flex space-x-3 items-center">
            {!showSearch && (
              <div onClick={handerShowModal} className="cursor-pointer" id="bell">
                {count && userInfo?.id ? imgBellMobile : imgBellDefaultMobile}
              </div>
            )}
            <div className="relative">
              <input
                value={text}
                onChange={onChange}
                onKeyPress={onKeyPress}
                className={showSearch ? "show__input__search" : "hide__input__search"}
                placeholder="Tìm kiếm"
              />
              <button
                onClick={onSearch}
                className="absolute text-dark-500 p-1 right-1 z-20 top-1/2 transform -translate-y-1/2 rounded cursor-pointer"
              >
                {iconSearch}
              </button>
            </div>
            <Link
              href="/subscription"
              onClick={() => {
                CloseModle()
              }}
            >
              <button
                className={
                  "rounded-3xl py-1 px-3 text-xs flex items-center bg-primary-500 hover:bg-primary-hover font-bold text-white justify-center w-[80px]"
                }
                style={{ backgroundImage: "linear-gradient(183.51deg, #52B5F9 5.4%, #024EC0 97.93%)" }}
              >
                Mua Gói
              </button>
            </Link>
          </div>
          {isShowNoti && <NotiCation callBackgetCountNoti={getCountNoti} setIsShowNoti={setIsShowNoti} />}
          {isShowNotiWarring && <PopupWarring setIsShowNotiWarring={setIsShowNotiWarring} />}
          <NavbarMobile listMenus={listMenus} isNav={isNav} setIsNav={togleNav} />
        </nav>
      )}
    </div>
  )
}

const imgBell = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 17V11.8C18.5 11.9 18 12 17.5 12H17V18H7V11C7 8.2 9.2 6 12 6C12.1 4.7 12.7 3.6 13.5 2.7C13.2 2.3 12.6 2 12 2C10.9 2 10 2.9 10 4V4.3C7 5.2 5 7.9 5 11V17L3 19V20H21V19L19 17ZM10 21C10 22.1 10.9 23 12 23C13.1 23 14 22.1 14 21H10ZM21 6.5C21 8.4 19.4 10 17.5 10C15.6 10 14 8.4 14 6.5C14 4.6 15.6 3 17.5 3C19.4 3 21 4.6 21 6.5Z"
      fill="white"
      fillOpacity="0.87"
    />
    <circle cx="17.5" cy="6.5" r="3.5" fill="#EF4035" />
  </svg>
)
const imgBellMobile = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 17V11.8C18.5 11.9 18 12 17.5 12H17V18H7V11C7 8.2 9.2 6 12 6C12.1 4.7 12.7 3.6 13.5 2.7C13.2 2.3 12.6 2 12 2C10.9 2 10 2.9 10 4V4.3C7 5.2 5 7.9 5 11V17L3 19V20H21V19L19 17ZM10 21C10 22.1 10.9 23 12 23C13.1 23 14 22.1 14 21H10ZM21 6.5C21 8.4 19.4 10 17.5 10C15.6 10 14 8.4 14 6.5C14 4.6 15.6 3 17.5 3C19.4 3 21 4.6 21 6.5Z"
      fill="white"
      fillOpacity="0.87"
    />
    <circle cx="17.5" cy="6.5" r="3.5" fill="#EF4035" />
  </svg>
)

const imgBellDefault = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="white" fillOpacity="0.87" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 28H18.6667C18.6667 29.4667 17.4667 30.6667 16 30.6667C14.5333 30.6667 13.3333 29.4667 13.3333 28ZM28 25.3333V26.6667H4V25.3333L6.66667 22.6667V14.6667C6.66667 10.5333 9.33333 6.93333 13.3333 5.73333V5.33333C13.3333 3.86666 14.5333 2.66666 16 2.66666C17.4667 2.66666 18.6667 3.86666 18.6667 5.33333V5.73333C22.6667 6.93333 25.3333 10.5333 25.3333 14.6667V22.6667L28 25.3333ZM22.6667 14.6667C22.6667 10.9333 19.7333 8 16 8C12.2667 8 9.33333 10.9333 9.33333 14.6667V24H22.6667V14.6667Z"
      fill="white"
      fillOpacity="0.7"
    />
  </svg>
)
const imgBellDefaultMobile = (
  <svg width="24" height="24" viewBox="0 0 32 32" fill="white" fillOpacity="0.87" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 28H18.6667C18.6667 29.4667 17.4667 30.6667 16 30.6667C14.5333 30.6667 13.3333 29.4667 13.3333 28ZM28 25.3333V26.6667H4V25.3333L6.66667 22.6667V14.6667C6.66667 10.5333 9.33333 6.93333 13.3333 5.73333V5.33333C13.3333 3.86666 14.5333 2.66666 16 2.66666C17.4667 2.66666 18.6667 3.86666 18.6667 5.33333V5.73333C22.6667 6.93333 25.3333 10.5333 25.3333 14.6667V22.6667L28 25.3333ZM22.6667 14.6667C22.6667 10.9333 19.7333 8 16 8C12.2667 8 9.33333 10.9333 9.33333 14.6667V24H22.6667V14.6667Z"
      fill="white"
      fillOpacity="0.7"
    />
  </svg>
)

const iconSearch = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="white" fillOpacity="0.87" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5323 13.7084C16.2667 12.6129 16.6957 11.2946 16.6957 9.87756C16.6957 6.08527 13.6238 3 9.84784 3C6.07192 3 3 6.08527 3 9.87753C3 13.6698 6.07195 16.7551 9.84787 16.7551C11.2867 16.7551 12.6229 16.3067 13.7263 15.5424L19.184 21L21 19.1761L15.5323 13.7084ZM9.84787 14.8234C7.13849 14.8234 4.93416 12.6095 4.93416 9.88837C4.93416 7.16723 7.13845 4.95338 9.84787 4.95338C12.5573 4.95338 14.7616 7.16723 14.7616 9.8884C14.7616 12.6096 12.5573 14.8234 9.84787 14.8234Z"
      fill="white"
      fillOpacity="0.7"
    />
  </svg>
)

const logoMobile = (
  <svg width="110" height="27.5" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_26608_175895)">
      <path
        d="M29.985 4.32304C29.985 1.95804 28.069 0.0410391 25.705 0.0400391H10.711L0.00201416 10.847V25.74C0.00201416 28.105 1.91801 30.022 4.28201 30.023H19.284L29.985 19.216V4.32304Z"
        fill="#EC1C24"
      />
      <path
        d="M4.29101 0.0400391H4.27901C1.91701 0.0430391 0.00201416 1.95904 0.00201416 4.32304V10.847L10.711 0.0400391H4.29101Z"
        fill="#129648"
      />
      <path
        d="M25.699 30.0231H25.708C28.071 30.0201 29.986 28.1031 29.986 25.7401V19.2161L19.285 30.0231H25.7H25.699Z"
        fill="#0E61AD"
      />
      <path
        d="M22.6399 19.521C22.6489 19.537 22.6559 19.553 22.6649 19.569C22.6779 19.591 22.6909 19.614 22.7039 19.636C22.7129 19.651 22.7219 19.667 22.7309 19.682C22.7449 19.705 22.7609 19.728 22.7759 19.75C22.7849 19.764 22.7939 19.778 22.8029 19.792C22.8209 19.817 22.8389 19.842 22.8579 19.867C22.8659 19.878 22.8739 19.889 22.8819 19.9C22.9089 19.935 22.9379 19.97 22.9669 20.005C23.0809 20.137 23.1369 20.194 23.1539 20.2C23.7659 20.778 24.6089 21.015 25.4089 20.889C25.4339 20.885 25.4579 20.881 25.4829 20.876C25.9109 20.796 26.3249 20.612 26.6829 20.319C27.3059 19.808 27.6259 19.075 27.6229 18.338C27.6229 18.343 27.6229 18.348 27.6229 18.354V9.14203H25.4829V18.349C25.4829 18.547 25.3589 18.732 25.1569 18.804C24.8989 18.896 24.6139 18.767 24.5199 18.515C24.5199 18.515 24.5199 18.513 24.5189 18.512L23.6309 16.143L23.2139 15.031L21.6389 10.831C21.6319 10.813 21.6249 10.796 21.6179 10.778C21.6109 10.761 21.6039 10.743 21.5969 10.726C21.5869 10.703 21.5769 10.681 21.5669 10.659C21.5589 10.642 21.5519 10.626 21.5439 10.609C21.5329 10.586 21.5209 10.564 21.5089 10.542C21.5009 10.526 21.4929 10.51 21.4839 10.494C21.4709 10.471 21.4579 10.449 21.4449 10.427C21.4359 10.412 21.4269 10.396 21.4179 10.381C21.4029 10.358 21.3879 10.336 21.3729 10.313C21.3639 10.299 21.3549 10.285 21.3449 10.271C21.3269 10.246 21.3089 10.221 21.2899 10.196C21.2819 10.185 21.2739 10.174 21.2659 10.163C21.2379 10.127 21.2099 10.092 21.1799 10.058C21.0659 9.92603 21.0099 9.86903 20.9939 9.86303C20.3819 9.28503 19.5389 9.04803 18.7379 9.17403C18.7129 9.17803 18.6889 9.18203 18.6639 9.18703C18.2359 9.26603 17.8219 9.45103 17.4639 9.74403C16.8409 10.255 16.5209 10.988 16.5239 11.725C16.5239 11.72 16.5239 11.714 16.5239 11.709V20.921H18.6649V11.714C18.6649 11.516 18.7889 11.331 18.9909 11.259C19.2489 11.167 19.5339 11.296 19.6279 11.548C19.6279 11.549 19.6279 11.55 19.6279 11.551L20.5159 13.92L21.4889 16.509L22.6379 19.521"
        fill="white"
      />
      <path
        d="M7.70199 8.07904H8.77299C9.06899 8.07904 9.30899 8.31904 9.30899 8.61504V12.898C9.30899 13.194 9.06899 13.433 8.77399 13.433H7.70299C7.40699 13.433 7.16699 13.193 7.16699 12.897V8.61404C7.16699 8.31804 7.40699 8.07904 7.70199 8.07904Z"
        fill="white"
      />
      <path
        d="M10.379 9.57605V11.9901C11.341 12.6651 11.97 13.7821 11.97 15.047C11.97 17.1091 10.299 18.7801 8.237 18.7801C6.175 18.7801 4.504 17.1091 4.504 15.047C4.504 13.7831 5.133 12.666 6.095 11.9901V9.57705C3.91 10.433 2.362 12.5591 2.362 15.047C2.362 18.291 4.992 20.9221 8.237 20.9221C11.482 20.9221 14.112 18.2921 14.112 15.047C14.112 12.5591 12.564 10.433 10.379 9.57705V9.57605Z"
        fill="white"
      />
      <path
        d="M27.844 25.5441C27.844 25.7941 27.594 25.9961 27.285 25.9961H25.951V27.3311C25.951 27.6401 25.749 27.8911 25.499 27.8911H24.596C24.347 27.8911 24.144 27.6401 24.144 27.3311V26.0001H22.808C22.499 26.0001 22.249 25.7971 22.249 25.5481V24.6441C22.249 24.3941 22.5 24.1921 22.808 24.1921H24.142V22.8571C24.142 22.5481 24.344 22.2971 24.594 22.2971H25.498C25.747 22.2971 25.949 22.5481 25.949 22.8571V24.1881H27.285C27.594 24.1881 27.844 24.3901 27.844 24.6401V25.5441Z"
        fill="white"
      />
      <path
        d="M57.498 11.404L54.431 19.58H52.368L49.301 11.404H51.364L53.395 16.962L55.436 11.404H57.499H57.498Z"
        fill="white"
      />
      <path d="M60.5441 8.336H58.4921V10.409H60.5441V8.336Z" fill="white" />
      <path d="M60.5441 11.382H58.4921V19.58H60.5441V11.382Z" fill="white" />
      <path
        d="M76.896 19.601H74.962C74.898 19.344 74.834 19.131 74.77 18.81C74.145 19.391 73.301 19.679 72.451 19.601C71.811 19.631 71.178 19.455 70.645 19.099C70.094 18.714 69.783 18.071 69.822 17.4C69.735 16.468 70.238 15.58 71.083 15.177C71.845 14.907 72.639 14.742 73.445 14.685C74.289 14.578 74.706 14.354 74.706 14.001C74.711 13.711 74.57 13.439 74.332 13.274C74.073 13.092 73.762 12.998 73.445 13.007C73.127 12.999 72.815 13.097 72.558 13.285C72.276 13.487 72.099 13.805 72.077 14.151H70.089C70.106 13.608 70.26 13.079 70.538 12.612C70.835 12.185 71.262 11.866 71.756 11.704C72.329 11.503 72.934 11.405 73.541 11.415C75.775 11.415 76.897 12.484 76.897 14.621V19.602L76.896 19.601ZM74.684 15.625C74.36 15.831 73.995 15.966 73.615 16.02C73.218 16.072 72.83 16.177 72.461 16.33C72.097 16.512 71.882 16.897 71.916 17.303C71.916 17.891 72.226 18.179 72.846 18.179C73.151 18.174 73.453 18.108 73.733 17.987C73.993 17.878 74.227 17.714 74.417 17.506C74.649 17.176 74.759 16.775 74.727 16.373V15.988C74.727 15.817 74.684 15.699 74.684 15.625Z"
        fill="white"
      />
      <path
        d="M86.1521 15.593C86.1911 16.566 85.9051 17.525 85.3401 18.318C84.7081 19.148 83.7111 19.619 82.6681 19.579C81.6551 19.588 80.6891 19.15 80.0281 18.382V21.663H77.9651V11.436H80.0061V12.633C80.6631 11.933 81.5601 11.509 82.5181 11.447C83.2171 11.447 83.9031 11.643 84.4951 12.013C85.0431 12.371 85.4711 12.885 85.7241 13.488C86.0151 14.151 86.1611 14.869 86.1521 15.594V15.593ZM83.8651 15.593C83.8651 14.022 83.2241 13.231 81.9411 13.231C80.6581 13.231 80.0601 14.107 80.0601 15.7C80.0421 16.293 80.2531 16.871 80.6481 17.314C80.9841 17.677 81.4571 17.883 81.9521 17.88C82.4491 17.892 82.9261 17.685 83.2561 17.314C83.6711 16.839 83.8891 16.224 83.8651 15.593Z"
        fill="white"
      />
      <path
        d="M94.3391 19.601H92.201V14.567C92.235 14.168 92.146 13.769 91.944 13.423C91.665 13.137 91.273 12.992 90.875 13.028C90.421 13.002 89.9811 13.193 89.6891 13.541C89.3981 13.9 89.247 14.351 89.261 14.813V19.601H87.123V8.336H89.261V12.536C89.456 12.168 89.7741 11.881 90.1591 11.724C90.6071 11.515 91.097 11.409 91.591 11.414C92.265 11.391 92.927 11.594 93.472 11.991C94.053 12.446 94.376 13.156 94.338 13.893V19.6L94.3391 19.601Z"
        fill="white"
      />
      <path
        d="M111.76 19.601H109.622V14.567C109.656 14.168 109.567 13.769 109.365 13.423C109.086 13.137 108.694 12.992 108.296 13.028C107.842 13.002 107.402 13.193 107.11 13.541C106.822 13.901 106.674 14.353 106.693 14.813V19.601H104.555V11.404H106.693V12.537C106.884 12.17 107.198 11.882 107.58 11.725C108.028 11.516 108.518 11.41 109.012 11.415C109.686 11.39 110.349 11.593 110.893 11.992C111.474 12.447 111.797 13.157 111.759 13.894V19.601H111.76Z"
        fill="white"
      />
      <path
        d="M68.73 19.601H66.592V14.567C66.626 14.168 66.537 13.769 66.335 13.423C66.056 13.137 65.664 12.992 65.266 13.028C64.812 13.002 64.372 13.193 64.08 13.541C63.792 13.901 63.644 14.353 63.663 14.813V19.601H61.525V11.404H63.663V12.537C63.851 12.168 64.166 11.879 64.55 11.725C64.998 11.516 65.488 11.41 65.982 11.415C66.656 11.39 67.319 11.593 67.863 11.992C68.444 12.447 68.767 13.157 68.729 13.894V19.601H68.73Z"
        fill="white"
      />
      <path
        d="M120 16.031H114.752C114.754 16.581 114.969 17.11 115.351 17.506C115.639 17.782 116.021 17.939 116.42 17.944C116.728 17.95 117.032 17.868 117.296 17.709C117.537 17.575 117.717 17.353 117.798 17.089H119.925C119.744 17.824 119.309 18.472 118.696 18.917C118.076 19.367 117.324 19.596 116.558 19.569C114.014 19.569 112.742 18.144 112.742 15.294C112.691 14.252 113.034 13.229 113.704 12.43C114.411 11.696 115.402 11.306 116.419 11.361C118.806 11.382 119.999 12.939 119.999 16.032L120 16.031ZM117.937 14.738C117.913 14.276 117.727 13.838 117.413 13.498C117.138 13.2 116.749 13.033 116.344 13.038C115.971 13.038 115.615 13.193 115.361 13.466C115.032 13.813 114.828 14.261 114.784 14.738H117.937Z"
        fill="white"
      />
      <path
        d="M103.541 15.497C103.599 16.597 103.214 17.675 102.472 18.49C100.764 19.993 98.2051 19.993 96.4981 18.49C95.7561 17.68 95.3711 16.605 95.4291 15.508C95.3731 14.408 95.7571 13.331 96.4981 12.515C98.2121 10.975 100.812 10.975 102.526 12.515C103.238 13.34 103.603 14.409 103.541 15.497ZM101.403 15.497C101.403 13.905 100.762 13.103 99.4791 13.103C98.1961 13.103 97.5451 13.905 97.5451 15.497C97.5451 17.089 98.1861 17.891 99.4791 17.891C100.772 17.891 101.403 17.089 101.403 15.486V15.497Z"
        fill="white"
      />
      <path opacity="0.5" d="M40.2 2.59998H39.1V27.4H40.2V2.59998Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_26608_175895">
        <rect width="120" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
